"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Represent the type of a position
 */
var PositionType;
(function (PositionType) {
    /**
     * At the begninning of a node
     */
    PositionType[PositionType["Begin"] = 0] = "Begin";
    /**
     * At the endo of a node
     */
    PositionType[PositionType["End"] = -1] = "End";
    /**
     * Before a node
     */
    PositionType[PositionType["Before"] = -2] = "Before";
    /**
     * After a node
     */
    PositionType[PositionType["After"] = -3] = "After";
})(PositionType = exports.PositionType || (exports.PositionType = {}));
//# sourceMappingURL=PositionType.js.map